import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the NumericoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'numerico',
})
export class NumericoPipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, padrao: string = '', ...args) { // ...args -> quando aceita infinitos argumentos?

        if (!value && padrao) return padrao;

        //return new Intl.NumberFormat('de-DE', {style: 'percent', currency: 'EUR'}).format(value);
        //return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
        return this.util.numerico(value);

    }

}

@Pipe({
    name: 'abs',
})
export class AbsolutePipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, ...args) { // ...args -> quando aceita infinitos argumentos?

        //return new Intl.NumberFormat('de-DE', {style: 'percent', currency: 'EUR'}).format(value);
        //return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
        return Math.abs(value);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/numerico/numerico.ts